import Vue from 'vue';
import moment from 'moment';
Vue.filter('formatTime',(val)=>{
    return moment(val).format('YYYY/MM/DD');
});

Vue.filter('formatDay',(val)=>{
    return moment(val).format('hh:mm:ss');
});